module.exports = {"annual":"annual","daily":"daily","monthly":"monthly","none":"none","weekly":"weekly"}